<!--
 * @Author: AnNa
 * @Date: 2021-08-09 11:29:15
 * @LastEditors: AnNa
 * @LastEditTime: 2021-08-19 09:55:42
 * @Description:
-->
<template>
  <a-modal
    :width="800"
    title="新增抽奖"
    :visible="visible"
    @ok="handleSubmit"
    @cancel="handleCancel"
    :confirm-loading="confirmLoading"
  >
    <a-form :form="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }" @submit="handleSubmit">
      <a-form-item label="商品ID">
        <a-input-group>
          <a-input style="width: 200px" v-decorator="['item_id', {rules: [{required: true, message: '必填项'}]}]" />
          <a-button @click="getGoods" :loading="resolveLoading">
            解析
          </a-button>
        </a-input-group>
      </a-form-item>
      <a-form-item label="奖品名称">
        <a-input
          placeholder="奖品名称"
          v-decorator="['item_name', { rules: [{ required: true, message: '必填项' }] }]"
        />
      </a-form-item>
      <a-form-item label="商品价格">
        <a-input
          placeholder="商品价格"
          v-decorator="['item_price', { rules: [{ required: true, message: '必填项' }] }]"
        />
      </a-form-item>
      <a-form-item label="奖品图片">
        <div class="clearfix">
          <a-upload
            accept=".jpg, .jpeg, .png"
            list-type="picture-card"
            :file-list="imgList"
            @change="handleImgChange"
            :customRequest="uploadImg"
          >
            <div v-if="imgList.length < 1">
              <a-icon type="plus" />
              <div class="ant-upload-text">上传图片</div>
            </div>
          </a-upload>
        </div>
        <a-input
          placeholder="奖品图片"
          v-decorator="['prize_img_url', { rules: [{ required: true, message: '必填项' }] }]"
        />
      </a-form-item>
      <a-form-item label="奖品数量">
        <a-input-number
          placeholder="奖品数量"
          v-decorator="['total_nums', { rules: [{ required: true, message: '必填项' }] }]"
        />
      </a-form-item>
      <a-form-item label="中奖概率">
        <a-input-number
          placeholder="中奖概率"
          v-decorator="['prize_rate', { rules: [{ required: true, message: '必填项' }] }]"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { LuckyAPI } from '@/api/lucky'
import { to } from '@/utils/await'
import { message } from 'ant-design-vue'
import { queryGoodInfo } from '@/api/pyq'
import { readFileAsBuffer, upload, uuid } from '@/utils/oss'

export default {
  data() {
    return {
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
      visible: false,
      confirmLoading: false,
      currentRobotId: null,
      info: null,
      imgList: [],
      resolveLoading: false
    }
  },

  methods: {
    show(record) {
      this.currentRobotId = record.sub_id
      this.info = record
      this.visible = true
    },
    copyText(text) {
      this.$copyText(text)
      this.$message.success('复制成功')
    },
    copyEmoji(emoji) {
      this.$copyText(emoji)
      this.$message.success('表情复制成功')
    },
    handleSelectSub() {
      this.$refs.robot.show()
    },
    handleImgChange({ fileList }) {
      this.imgList = fileList
    },
    uploadImg(file) {
      readFileAsBuffer(file.file)
        .then(builderFile => {
          upload(builderFile, file.file, 'images')
            .then(res => {
              file.onSuccess({
                name: res.data.name,
                status: 'done',
                thumbUrl: res.url,
                url: res.url
              })
              this.form.setFieldsValue({
                prize_img_url: res.url
              })
            })
            .catch(err => {
              file.onError(err)
            })
        })
        .catch(err => {
          file.onError(err)
        })
    },
    getGoods() {
      const goodsId = this.form.getFieldValue('item_id')
      if (!goodsId) return this.form.setFields({ item_id: { errors: [new Error('请先填写商品ID')] } })
      this.resolveLoading = true
      this.infoLoading = true
      queryGoodInfo({
        goods_id: goodsId,
        goods_type: 'tb'
      })
        .then(res => {
          this.$message.success('解析完成')
          if (res.code !== 1) {
            this.$message.error(res.msg)
            return false
          }
          this.form.setFieldsValue({
            prize_img_url: res.data.pict_url,
            item_name: res.data.title,
            item_price: res.data.reserve_price
          })
          const uid = uuid()
          this.imgList = [{
            uid,
            name: `${uid}.jpg`,
            status: 'done',
            url: res.data.pict_url
          }]
        })
        .finally(() => {
          this.resolveLoading = false
        })
      // })
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!err) {
          // console.log(values)

          const [msg] = await to(LuckyAPI.addLuckyGoods({
            prizes_data: JSON.stringify([values]),
            luckydraw_id: this.info.id,
            sub_id: this.currentRobotId
          }))
          if (!msg) {
            this.visible = false
            this.form.resetFields()
            this.$emit('ok')
            message.success('操作成功')
            return
          }
          message.success(msg)
        }
      })
    },
    handleCancel() {
      this.visible = false
    },
    handleOk(record) {
      this.form.setFieldsValue({
        robot_id: record.id,
        servant_id: record.servant_id
      })
    }
  }
}
</script>
